import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Camera, FileText, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { AnalysisResult } from "@/components/AnalysisResult";
import { SAMPLES } from "@/lib/demoSamples";
import { track } from "@/lib/api";

const SignupCta = () => (
  <div className="rounded-3xl bg-[#1E3A8A] text-white p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-5" data-testid="demo-signup-cta">
    <Camera className="h-8 w-8 text-[#E07A5F] shrink-0" />
    <div className="flex-1">
      <p className="text-lg font-medium">Ora prova con la tua lettera</p>
      <p className="text-sm text-blue-200">Account gratuito in 30 secondi: fotografi il documento, ricevi i passi da fare e le scadenze nel tuo calendario.</p>
    </div>
    <Button asChild className="rounded-full h-12 px-6 bg-[#E07A5F] hover:bg-[#d06a50]" data-testid="demo-signup-btn">
      <Link to="/accedi?mode=register" onClick={() => track("cta_click")}>Crea account gratis <ArrowRight className="ml-2 h-4 w-4" /></Link>
    </Button>
  </div>
);

export default function Demo() {
  const [pick, setPick] = useState(SAMPLES[0]);
  useEffect(() => {
    track("demo_view");
  }, []);
  return (
    <div className="min-h-screen bg-[#F9F9F6]" data-testid="demo-page">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b">
        <div className="max-w-6xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
          <Logo />
          <Button asChild className="rounded-full h-10 px-5 text-sm" data-testid="demo-header-cta"><Link to="/accedi?mode=register" onClick={() => track("cta_click")}>Inizia gratis</Link></Button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-5 md:px-8 py-10 md:py-14">
        <span className="inline-flex items-center gap-2 rounded-full border bg-white px-3 py-1 text-xs text-slate-600"><Sparkles className="h-3.5 w-3.5 text-[#E07A5F]" /> Prova senza account</span>
        <h1 className="mt-4 text-4xl sm:text-5xl font-semibold tracking-tight">Ecco cosa ti dice Burocrazy.</h1>
        <p className="mt-3 text-slate-600 max-w-2xl">Scegli una lettera di esempio e guarda l'analisi completa: cosa significa, cosa fare passo passo, le scadenze e quando serve il CAF.</p>
        <div className="mt-8 grid sm:grid-cols-3 gap-3" data-testid="demo-samples">
          {SAMPLES.map((s) => (
            <button key={s.id} onClick={() => setPick(s)} data-testid={`demo-sample-${s.id}`}
              className={`text-left rounded-2xl border p-4 transition-colors duration-200 ${pick.id === s.id ? "border-[#1E3A8A] bg-[#1E3A8A]/5" : "bg-white hover:border-slate-400"}`}>
              <FileText className={`h-5 w-5 ${pick.id === s.id ? "text-[#1E3A8A]" : "text-slate-400"}`} />
              <p className="mt-2 font-medium">{s.label}</p>
              <p className="text-xs text-slate-500">{s.hint}</p>
            </button>
          ))}
        </div>
        <p className="mt-6 text-xs text-slate-500" data-testid="demo-disclaimer">Esempio dimostrativo con dati inventati. Con il tuo account l'analisi viene fatta sul tuo documento reale.</p>
        <div className="mt-4 space-y-6">
          <AnalysisResult analysis={{ result: pick.result }} demo key={pick.id} />
          <SignupCta />
        </div>
      </main>
    </div>
  );
}
